export default __webpack_public_path__ + "static/media/penant.70fa7a05.svg";